import { Link } from "react-router-dom";
import { useLiveSlots, checkoutUrl, fmtDay } from "@/components/LiveSlots";

export function HeroDepartures() {
  const data = useLiveSlots();
  if (!data) return <div className="hidden lg:block h-[420px] rounded-2xl bg-[#1E3A2B]/70" />;
  const groups = {};
  data.safaris.forEach((sf) => sf.slots.filter((s) => !s.started && s.remaining_vehicles > 0).forEach((s) => {
    const k = s.shared_pool ? `${s.date}|${s.session}` : `${s.date}|${s.departure_time}|${sf.id}`;
    (groups[k] = groups[k] || { ...s, sfs: [] }).sfs.push(sf);
  }));
  const next = Object.values(groups)
    .sort((a, b) => `${a.date}${a.departure_time}`.localeCompare(`${b.date}${b.departure_time}`))
    .slice(0, 4);
  if (!next.length) return null;
  return (
    <div className="rounded-2xl bg-[#1E3A2B]/85 backdrop-blur-md ring-1 ring-white/10 p-5 md:p-6 text-[#F5F0EB] shadow-2xl shadow-black/30" data-testid="hero-departures">
      <div className="flex items-center gap-2.5 mb-4 font-medium">
        <span className="relative flex w-2.5 h-2.5">
          <span className="absolute inset-0 rounded-full bg-[#4ADE80] animate-ping opacity-60"/>
          <span className="relative w-2.5 h-2.5 rounded-full bg-[#4ADE80]"/>
        </span>
        Live safari departures
      </div>
      <div className="space-y-3">
        {next.map((s) => {
          const f = fmtDay(s.date);
          const sf = s.sfs.find((x) => x.slug === "jawai-leopard-safari") || s.sfs[0];
          const slot = sf.slots.find((x) => x.date === s.date && x.session === s.session && !x.started && x.remaining_vehicles > 0) || s;
          return (
            <Link key={s.id} to={checkoutUrl(sf.id, slot)} data-testid={`hero-departure-${s.id}`}
              className="flex items-center justify-between gap-4 rounded-xl bg-white/[0.06] hover:bg-white/[0.12] px-4 py-3.5 transition-colors duration-200">
              <div className="min-w-0">
                <div className="text-base">{s.session === "morning" ? "Morning" : "Evening"} Safari · {s.departure_time}</div>
                <div className="text-sm text-white/65 truncate">{f.day} {f.mon} · {s.sfs.map((x) => x.name.replace(/^Jawai\s+|\s+Safari$/g, "")).join(" · ")}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-display text-2xl text-[#D4A359] leading-none" data-testid={`hero-departure-left-${s.id}`}>{s.remaining_vehicles}</div>
                <div className="text-[10px] uppercase tracking-[0.15em] text-white/60 mt-1">Jeeps left</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
